import { ENTITY_PREFIX, FreeformId, PollId } from "../../shared/models/entity.model";
import { requiresStart } from "../models/interactive.model";
import { InteractiveListItem, InteractivePatch } from "../models/interactives-list.model";
import { StateChangeAction } from "../models/interactives-list.view";

export function toInteractiveTypedId(interactive: InteractiveListItem): PollId | FreeformId {
    const prefix = interactive.isPoll ? ENTITY_PREFIX.INTERACTIVE_POLL : ENTITY_PREFIX.INTERACTIVE_FREEFORM;
    return `${prefix}:${interactive.id}`;
}

/** Builds the update body for each state change. Delete has no body and is handled separately. */
export const INTERACTIVE_PATCH_BUILDERS: Record<
    Exclude<StateChangeAction, "delete">,
    (item: InteractiveListItem) => InteractivePatch
> = {
    pause: () => ({ state: "PAUSED" }),
    resume: () => ({ state: "PUBLISHED" }),
    archive: () => ({ state: "ARCHIVED" }),
    // No CLOSED state exists - closing forces the end date to now so the row derives to CLOSED.
    // The time window is widened to include an end date, preserving any existing start requirement.
    // A PAUSED interactive must also be moved back to PUBLISHED - otherwise it stays PAUSED
    // server-side and never derives to CLOSED, leaving the badge stuck on "Paused".
    close: item => ({
        ...(item.state === "PAUSED" ? { state: "PUBLISHED" } : {}),
        timeWindow: requiresStart(item.timeWindow) ? "START_AND_END" : "END_ONLY",
        endDate: new Date().toISOString()
    })
};
